import { Injectable } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { environment } from "../../../../../environments/environment";
import { Subject, Subscription, firstValueFrom, take, catchError, of } from "rxjs";
import { Router } from "@angular/router";
import { SessionService } from "../../../shared/services/Session.service";
import { SignalRService } from "../../../shared/services/Signal-R.service";
import { SignalUser } from "../../../shared/models/SignalUser/SignalUser";
import { EnumFolderPaths } from "../../../shared/helpers/enums/EnumFolderPaths";
import { UrlSasDTO } from "../../../shared/models/AzureStorage/UrlSasDTO";
import { SystemNotificationCatalogService } from "../../../ui/molecules/system-notification/services/systemNotificationCatalog.service";
import { AuthService } from "../../authmanagement/services/Auth.service";
import { NotificationService } from "../../notifications/services/Notification.service";
import { TutorialService } from "../../../ui/organisms/tutorial/services/tutorial.service";
import { EncriptionService } from "../../../shared/services/Encription.service";
import { AzureStorageService } from "../../../shared/services/ServiceCatalogEncapsulators/AzureStorage.service";
import { EnumsService } from "../../../shared/services/ServiceCatalogEncapsulators/Enums.service";
import { PermissionsService } from "../../../shared/services/ServiceCatalogEncapsulators/Permissions.service";
import { SignalUserService } from "../../../shared/services/ServiceCatalogEncapsulators/Signal-User.service";
import { UserConfigurationsService } from "../../../shared/services/ServiceCatalogEncapsulators/UserConfigurations.service";
import { ViewsService } from "../../../shared/services/ServiceCatalogEncapsulators/Views.service";
import { LocationCategoriesService } from "../../../map-features/sections/locations-section/services/LocationCategories.service";
import { ImageCacheService } from "../../../shared/services/ImageCache.service";
import { LocationsService } from "../../../map-features/sections/locations-section/services/Locations.service";
import { CitronellaExternalAPIService } from "../../../shared/services/External API/CitronellaExternalAPI.service";
import { ThirdPartySettingsService } from "../../../shared/services/ServiceCatalogEncapsulators/ThirdPartySettings.service";
import { CallbackAPIService } from "../../../shared/services/API/CallbackAPI.service";
import { WebCallbackDTO } from "../../../shared/models/CallBack/WebCallbackDTO";
import { LocalStorageService } from "../../../shared/services/LocalStorage.service";
import { EnumExternalMapUrl, EnumMapUrl, EnumUnifiedMapUrlByCustomerTypeId } from "../../../shared/helpers/enums/EnumCatalogNames copy";
import { LayerService } from "../../../map-features/sections/locations-section/services/Layers.service";

@Injectable({
  providedIn: "root",
})
export class CallBackService {
  configUrl: string;
  public isReloading: boolean = false;
  public clientes: any = [];
  isMapix: boolean;
  IsAdmin: boolean = false;
  IsSuperuser: boolean = false;
  returnRoles = {
    IsAdmin: false,
    IsSuperuser: false
  };
  isCallBackActive: boolean = false;
  isCallBackSuccesfull: boolean = false;

  SignalUser: SignalUser = new SignalUser();

  private clientes$: Subject<any> = new Subject();
  private clienteDisplay$: Subject<string> = new Subject();
  private views$: Subject<string[]> = new Subject();

  constructor(
    private callbackAPIService: CallbackAPIService,
    private UserConfigurationService: UserConfigurationsService,
    private router: Router,
    private authService: AuthService,
    private sessionService: SessionService,
    private permissionService: PermissionsService,
    private encriptionService: EncriptionService,
    private viewService: ViewsService,
    private signalUserService: SignalUserService,
    private signalRService: SignalRService,
    private azureStorageService: AzureStorageService,
    private locationCategoriesService: LocationCategoriesService,
    private tutorialService: TutorialService,
    private enumCatalogService: EnumsService,
    private systemNotificationService: SystemNotificationCatalogService,
    private notificationService: NotificationService,
    private imageCache: ImageCacheService,
    private locationsService: LocationsService,
    private thirdPartySettingsService: ThirdPartySettingsService,
    private citronellaExternalAPIService: CitronellaExternalAPIService,
    private localStorageService: LocalStorageService,
    private layerService : LayerService
  ) {
    this.configUrl = environment.host;
    this.checkingURL();

  }

  setClientes(resp) {
    this.clientes$.next(resp);
  }

  setClienteDisplay(resp) {
    this.clienteDisplay$.next(resp);
  }

  setViews(resp) {
    this.views$.next(resp);
  }

  getClientes() {
    return this.clientes$.asObservable();
  }

  getClienteDisplay() {
    return this.clienteDisplay$.asObservable();
  }

  getViews() {
    return this.views$.asObservable();
  }

  async isNeededCallback() {
    if (!(this.router.url.includes("login"))) {

      const isMinifiedCallbackNeeded =
        this.localStorageService.getPermissions() == "" ||
        // this.localStorageService.getPermissions().length == 0 ||
        this.localStorageService.getPermissions() == null ||
        this.localStorageService.getListaCategorias() == null ||
        this.localStorageService.getListaCategorias() == "" ||
        this.localStorageService.getUrlList() == null ||
        this.localStorageService.getUrlList() == "" ;

      const isMainCallbackNeeded = this.localStorageService.getUserRol() == "" ||
        this.localStorageService.getUserRol() == null ||
        this.localStorageService.getUserRol().length == 0 ||
        isMinifiedCallbackNeeded;

      //revisa si el usuario tiene los datos de localstorgae
      if (isMainCallbackNeeded){
        if (this.localStorageService.getToken()==null || this.localStorageService.getToken()=="")
          this.authService.Logout();  
        
        // if (!this.isCallBackActive && !this.sessionService.isExternalMap.value) {
        if (!this.isCallBackActive) {
          const mapUrl = this.getMapUrl();
          var externalMapNames = Object.values(EnumExternalMapUrl).map(x => x.toString());
          if(externalMapNames.includes(mapUrl)){
            if(isMinifiedCallbackNeeded)
              await this.minifiedCallback();
          }else{
            await this.dataCallbackOneCall(false);
            this.assignNavbarValues();
          }
        }
      }else{
        if(this.imageCache.isMapixImagesEmpty()){
          // this.imageCache.setAllMapixImages();
        }

        this.assignNavbarValues();
      }
    }
  }

  //se puede reasignar a servicios diferentes cada observable
  assignNavbarValues() {
    var rolEncriptado = JSON.parse(this.localStorageService.getUserRol());
    var rolDecriptado = rolEncriptado.map((role) =>
      this.encriptionService.DecryptData(role)
    );
    this.authService.setRole(rolDecriptado);
    this.setViews(this.encriptionService.DecryptViews());
    
    var clienteEncriptado = JSON.parse(this.localStorageService.getListaClientes());
    var clientesDecriptado = clienteEncriptado.map((client) =>
      this.encriptionService.DecryptData(client)
    );
    var clientes = clienteEncriptado == null ? [] : clientesDecriptado;
    this.setClientes(clientes);

    var clienteDisplayDecriptado = this.encriptionService.DecryptData(this.localStorageService.getClienteSeleccionado());
    var clienteDisplay = clienteDisplayDecriptado == null ? "Cargando...": clienteDisplayDecriptado;
    this.setClienteDisplay(clienteDisplay);
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  async dataCallback() {
    if(!environment.production) console.log("CallBackService - dataCallback");
    
    this.isCallBackActive = true;
   
    const [dataPermissions, viewPermissions, dataRol, dataClient, DeleteByUser, categories, categoriesImageUri, shownTutorial, systemNotification, mainMapGeoJson, urlSettings] = await Promise.all([
      firstValueFrom(this.permissionService.GetList().pipe(take(1))),
      firstValueFrom(this.viewService.getPermissionList().pipe(take(1))),
      firstValueFrom(this.UserConfigurationService.getUserRoles().pipe(take(1))),
      firstValueFrom(this.UserConfigurationService.GetByUserIdWithDefault().pipe(take(1))),
      firstValueFrom(this.signalUserService.DeleteByUser().pipe(take(1))),
      firstValueFrom(this.locationCategoriesService.getList().pipe(take(1))),
      firstValueFrom(this.azureStorageService.GetFolderFilesUrl(EnumFolderPaths.Location_Categories_Icons).pipe(take(1))),
      firstValueFrom(this.tutorialService.GetShownTutorials().pipe(take(1))),
      firstValueFrom(this.systemNotificationService.GetActive().pipe(take(1))),
      firstValueFrom(this.layerService.GetLayerGPSGeoJson().pipe(take(1))),
      firstValueFrom(this.thirdPartySettingsService.getCitronellaImagesSettings().pipe(take(1))),
      // firstValueFrom(this.onWebCallback().pipe(take(1)))
    ]);
  
    try{
      this.dataPermissions(dataPermissions, viewPermissions);
    }catch(e){
      if(!environment.production) console.log(e);
    }
    if (dataRol.isSuccess) {
      const roles = dataRol.result.map(role => this.encriptionService.EncryptData(role));
      this.localStorageService.setUserRol(JSON.stringify(roles));
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: dataRol isSuccess false', { level: 'warning', extra: { response: dataRol } });
    }
  
    if (dataClient.isSuccess) {
      this.UserConfigurationService.clientes = dataClient.result;
      const encriptedClients = dataClient.result.map(client => this.encriptionService.EncryptData(client));
      this.localStorageService.setListaClientes(JSON.stringify(encriptedClients));
      //this.localStorageService.setListaClientes(JSON.stringify(dataClient.result));
      if (this.localStorageService.getClienteSeleccionado() == null || this.localStorageService.getClienteSeleccionado() == "") {
        this.localStorageService.setClienteSeleccionado(this.encriptionService.EncryptData(dataClient.result[0].customerName));
        this.localStorageService.setClienteSeleccionadoId(this.encriptionService.EncryptData(dataClient.result[0].idCustomer));
        this.localStorageService.setClienteSeleccionadoTypeId(this.encriptionService.EncryptData(dataClient.result[0].idCustomerType));
      }
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: dataClient isSuccess false', { level: 'warning', extra: { response: dataClient } });
    }
  
    if (categories.isSuccess) {
      this.locationCategoriesService.categories = categories.result;
      this.localStorageService.setListaCategorias(JSON.stringify(categories.result));
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: categories isSuccess false', { level: 'warning', extra: { response: categories } });
    }
  
    // aquí se pueden agregar más llamadas a uris de azure storage
    var urlList: UrlSasDTO[] = [];
    if (categoriesImageUri.isSuccess) {
      urlList.push(...categoriesImageUri.result);
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: categoriesImageUri isSuccess false', { level: 'warning', extra: { response: categoriesImageUri } });
    }

    this.localStorageService.setUrlList(JSON.stringify(urlList));
    // this.imageCache.setAllMapixImages();


    var shownTutorials: string[] = [];
    if (shownTutorial.isSuccess) {
      shownTutorials.push(...shownTutorial.result);
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: shownTutorial isSuccess false', { level: 'warning', extra: { response: shownTutorial } });
    }
    this.localStorageService.setShownTutorials(JSON.stringify(shownTutorials));

    if (systemNotification.isSuccess) {
      this.localStorageService.setSystemNotification(JSON.stringify(systemNotification.result));
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: systemNotification isSuccess false', { level: 'warning', extra: { response: systemNotification } });
    }

    // if (mainMapGeoJson.isSuccess) {
    //   this.locationsService.mainGeoJsonData = JSON.parse(mainMapGeoJson.result);
    // } else {
    //   Sentry.captureMessage('CallBackService.dataCallback: mainMapGeoJson isSuccess false', { level: 'warning', extra: { response: mainMapGeoJson } });
    // }

    this.notificationService.getActiveNotificationsCount();
    this.notificationService.getNotifications(1);

    if (this.enumCatalogService.enumCatalog == null || this.enumCatalogService.enumCatalog == undefined || this.enumCatalogService.enumCatalog.length == 0) {
      this.enumCatalogService.setEnumCatalogs();
    }

    if (urlSettings.isSuccess) {
      this.citronellaExternalAPIService.setUrlSettings(urlSettings.result.url, urlSettings.result.path, urlSettings.result.token);
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: urlSettings isSuccess false', { level: 'warning', extra: { response: urlSettings } });
    }


    this.isCallBackActive = false;
  }

  async dataCallbackOneCall(isRequiredUpdateClientId: boolean) {
    if(!environment.production) console.log("CallBackService - dataCallback - one call");
    
    this.isCallBackActive = true;

    const [onWebCallback] = await Promise.all([
      firstValueFrom(
        this.onWebCallback(isRequiredUpdateClientId).pipe(
          take(1),
          catchError((error) => {
            console.error('Error en callback:', error);
            this.isCallBackSuccesfull = false;
            return of({ isSuccess: false, result: null, message: error.message || 'Error desconocido' });
          })
        )
      )
    ]);

    if(!environment.production) console.log("onWebCallback", onWebCallback);


    const response = onWebCallback.result as WebCallbackDTO;
    if (onWebCallback.isSuccess && response) {
      try{
        var views = [];
        var permissions = [];
        if (response.permission_GetList) {
          if(!environment.production) console.log("permissions", response.permission_GetList);
          permissions = response.permission_GetList.map(permission => permission.shortName);
        }

        if (response.view_GetPermissionList) {
          views = response.view_GetPermissionList.map(view => view.name);
          var viewsEncriptado = this.encriptionService.EncryptData(response.view_GetPermissionList)
          this.localStorageService.setViews(viewsEncriptado);
        }
        const  viewsPermissions = views.concat(permissions);
        const viewsPermissionsEncription = viewsPermissions.map((view) => {
          return this.encriptionService.EncryptData(view);
        });
        this.localStorageService.setPermissions(JSON.stringify(viewsPermissionsEncription));
      }catch(e){
        if(!environment.production) console.log(e);
      }
      if (response.userConfiguration_GetUserRoles) {
        const roles = response.userConfiguration_GetUserRoles.map(role => this.encriptionService.EncryptData(role));
        this.localStorageService.setUserRol(JSON.stringify(roles));
      }

      if (response.userConfiguration_GetByUserIdWithDefault) {
        this.UserConfigurationService.clientes = response.userConfiguration_GetByUserIdWithDefault;
        const encriptedClients = response.userConfiguration_GetByUserIdWithDefault.map(client => this.encriptionService.EncryptData(client));
        this.localStorageService.setListaClientes(JSON.stringify(encriptedClients));
        //this.localStorageService.setListaClientes(JSON.stringify(dataClient.result));
        if (this.localStorageService.getClienteSeleccionado() == null || this.localStorageService.getClienteSeleccionado() == "") {
          this.localStorageService.setClienteSeleccionado(this.encriptionService.EncryptData(response.userConfiguration_GetByUserIdWithDefault[0].customerName));
          this.localStorageService.setClienteSeleccionadoId(this.encriptionService.EncryptData(response.userConfiguration_GetByUserIdWithDefault[0].idCustomer));
          this.localStorageService.setClienteSeleccionadoTypeId(this.encriptionService.EncryptData(response.userConfiguration_GetByUserIdWithDefault[0].idCustomerType));
        }
      }

      if (response.locationCategory_GetList) {
        this.locationCategoriesService.categories = response.locationCategory_GetList;
        this.localStorageService.setListaCategorias(JSON.stringify(response.locationCategory_GetList));
      }
    
      // aquí se pueden agregar más llamadas a uris de azure storage
      var urlList: UrlSasDTO[] = [];
      if (response.azureStorage_GetFolderFilesUrl) {
        urlList.push(...response.azureStorage_GetFolderFilesUrl);
      }
      if(!environment.production) console.log(urlList);

      this.localStorageService.setUrlList(JSON.stringify(urlList));
      // this.imageCache.setAllMapixImages();
      
      var urlMapList: UrlSasDTO[] = [];
      if (response.azureStorage_GetFolderFilesUrl) {
        urlMapList.push(...response.azureStorage_GetFolderFilesUrl);
      }
      if(!environment.production) console.log(urlMapList);
      this.localStorageService.setUrlMapList(JSON.stringify(urlMapList));
      
      try {
        await this.imageCache.ensureInitialized();
        await this.imageCache.setAllMapixImagesOnDB();
      } catch (imageError) {
        console.error('Error inicializando ImageCache:', imageError);
        Sentry.captureException(imageError);
      }
  
  
      var shownTutorials: string[] = [];
      if (response.userTutorial_GetNamesListByUserId) {
        shownTutorials.push(...response.userTutorial_GetNamesListByUserId);
      }
      this.localStorageService.setShownTutorials(JSON.stringify(shownTutorials));

      if (response.systemNotification_GetActive) {
        this.localStorageService.setSystemNotification(JSON.stringify(response.systemNotification_GetActive));
      }
  
      // if (response.location_GetLayerGPSGeoJson) {
      //   this.locationsService.mainGeoJsonData = JSON.parse(response.location_GetLayerGPSGeoJson);
      // }

      if (response.thirdPartySettings_GetCitronellaImagesSettings) {
        this.citronellaExternalAPIService.setUrlSettings(response.thirdPartySettings_GetCitronellaImagesSettings.url, response.thirdPartySettings_GetCitronellaImagesSettings.path, response.thirdPartySettings_GetCitronellaImagesSettings.token);
      }

      if (response.user) {
        const firstName = response.user.userName ? response.user.userName : '';
        const lastName = response.user.lastName ? response.user.lastName : '';
        const secondLastName = response.user.secondLastName ? response.user.secondLastName : '';
        const fullName = firstName + ' ' + lastName + ' ' + secondLastName;
        // console.log("Full Name:", fullName, response.user);
        this.localStorageService.setRegularName(fullName);
      }else{
        this.localStorageService.setRegularName("");
      }
      
      // ultimos pasos, después de configuracion del callback

      this.SignalUser = new SignalUser();
      
      try {
        this.signalRService.startConnection();
        await this.signalRService.waitForConnectionId(10000);
        this.subscribeSignalUser();
      } catch (signalRError) {
        console.warn('Error en conexión de SignalR:', signalRError);
        Sentry.captureException(signalRError);
      }
  
      this.notificationService.getActiveNotificationsCount();
      this.notificationService.getNotifications(1);
  
      if (this.enumCatalogService.enumCatalog == null || this.enumCatalogService.enumCatalog == undefined || this.enumCatalogService.enumCatalog.length == 0) {
        this.enumCatalogService.setEnumCatalogs();
      }
  
      this.isCallBackActive = false;
      this.isCallBackSuccesfull = true;
    }else{
      this.isCallBackActive = false;
      this.isCallBackSuccesfull = false;
      Sentry.captureMessage('CallBackService.dataCallbackOneCall: onWebCallback isSuccess false', { level: 'warning', extra: { response: onWebCallback } });
    }
    
  }

  async minifiedCallback() {
    if(!environment.production) console.log("CallBackService - dataCallback");
    
    this.isCallBackActive = true;
   
    const [dataPermissions, viewPermissions, categories, categoriesImageUri, shownTutorial, dataClient] = await Promise.all([
      firstValueFrom(this.permissionService.GetList().pipe(take(1))),
      firstValueFrom(this.viewService.getPermissionList().pipe(take(1))),
      firstValueFrom(this.locationCategoriesService.getList().pipe(take(1))),
      firstValueFrom(this.azureStorageService.GetFolderFilesUrl(EnumFolderPaths.Location_Categories_Icons).pipe(take(1))),
      firstValueFrom(this.tutorialService.GetShownTutorials().pipe(take(1))),
      firstValueFrom(this.UserConfigurationService.GetByUserIdWithDefault().pipe(take(1))),
    ]);
  
    try{
      this.dataPermissions(dataPermissions, viewPermissions);
    }catch(e){
      if(!environment.production) console.log(e);
    }

  
    if (categories.isSuccess) {
      this.locationCategoriesService.categories = categories.result;
      this.localStorageService.setListaCategorias(JSON.stringify(categories.result));
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: categories isSuccess false', { level: 'warning', extra: { response: categories } });
    }
  
    // aquí se pueden agregar más llamadas a uris de azure storage
    var urlList: UrlSasDTO[] = [];
    if (categoriesImageUri.isSuccess) {
      urlList.push(...categoriesImageUri.result);
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: categoriesImageUri isSuccess false', { level: 'warning', extra: { response: categoriesImageUri } });
    }

    this.localStorageService.setUrlList(JSON.stringify(urlList));
    this.localStorageService.setUrlMapList(JSON.stringify(urlList));

    if(dataClient.isSuccess && dataClient.result && dataClient.result.length > 0){
      this.UserConfigurationService.clientes = dataClient.result;
      const encriptedClients = dataClient.result.map(client => this.encriptionService.EncryptData(client));
      this.localStorageService.setListaClientes(JSON.stringify(encriptedClients));
      //this.localStorageService.setListaClientes(JSON.stringify(dataClient.result));
      if (this.localStorageService.getClienteSeleccionado() == null || this.localStorageService.getClienteSeleccionado() == "") {
        this.localStorageService.setClienteSeleccionado(this.encriptionService.EncryptData(dataClient.result[0].customerName));
        this.localStorageService.setClienteSeleccionadoId(this.encriptionService.EncryptData(dataClient.result[0].idCustomer));
        this.localStorageService.setClienteSeleccionadoTypeId(this.encriptionService.EncryptData(dataClient.result[0].idCustomerType));
      }
    }

    this.imageCache.startBackgroundImageLoad();

    var shownTutorials: string[] = [];
    if (shownTutorial.isSuccess) {
      shownTutorials.push(...shownTutorial.result);
    } else {
      Sentry.captureMessage('CallBackService.dataCallback: shownTutorial isSuccess false', { level: 'warning', extra: { response: shownTutorial } });
    }
    this.localStorageService.setShownTutorials(JSON.stringify(shownTutorials));

    this.isCallBackActive = false;
    this.isCallBackSuccesfull = true;
  }

  dataPermissions(dataPermissions, viewPermissions) {
    
    var views = [];
      var permissions = [];
      if (dataPermissions.isSuccess) {
        if(!environment.production) console.log("permissions",dataPermissions.result);
        permissions = dataPermissions.result.map(permission => permission.shortName);
      }

      if (viewPermissions.isSuccess) {
        views = viewPermissions.result.map(view => view.name);
        if(!environment.production) console.log("views",viewPermissions.result);
        var viewsEncriptado = this.encriptionService.EncryptData(viewPermissions.result)
        this.localStorageService.setViews(viewsEncriptado);
      }
      const  viewsPermissions = views.concat(permissions);
      const viewsPermissionsEncription = viewsPermissions.map((view) => {
        return this.encriptionService.EncryptData(view);
      });
      this.localStorageService.setPermissions(JSON.stringify(viewsPermissionsEncription));
  }

  subscribeSignalUser(){
    this.SignalUser.ConnectionId = this.signalRService.ConnectionId;
    if(!environment.production) console.log("SignalUser ConnectionId: ", this.SignalUser.ConnectionId);
    this.signalUserService.DeleteByUser().pipe(take(1)).subscribe(() => {
      if(!environment.production) console.log("Eliminada subscripción anterior");
    });
    this.signalUserService.SubscribeGeneralSignalUserService(this.SignalUser);
    this.signalRService.ActivateListenerNewNotification();
  }

  onWebCallback(isRequiredUpdateClientId: boolean){
    return this.callbackAPIService.OnWebCallback(isRequiredUpdateClientId);
  }

  getMapUrl(){
    const savedRedirectUrl = this.localStorageService.getRedirectUrl();

    const externalMapNames = Object.values(EnumExternalMapUrl).map(x => x.toString());
    if (savedRedirectUrl && externalMapNames.includes(savedRedirectUrl)){
      return savedRedirectUrl;
    }else{
      const clientName = this.encriptionService.DecryptData(this.localStorageService.getClienteSeleccionado());
      const clientTypeId = this.encriptionService.DecryptData(this.localStorageService.getClienteSeleccionadoTypeId());
      const keys = Object.keys(EnumUnifiedMapUrlByCustomerTypeId);
  
      
      const idKey = keys[(clientTypeId - 1)] || "";
      console.log("ClientTypeId", clientTypeId, "idKey", idKey, "clientName", EnumUnifiedMapUrlByCustomerTypeId[idKey]);
      if(idKey){
        return EnumUnifiedMapUrlByCustomerTypeId[idKey];
      } else {
        return EnumUnifiedMapUrlByCustomerTypeId.uno;
      }
  
      const keys2 = Object.keys(EnumMapUrl);
      const foundKey = keys2.find(key => key.replace(/_/g, '').toLowerCase() === clientName.replace(/ /g, '').toLowerCase());
      if(foundKey){
        return EnumMapUrl[foundKey];
      } else {
        return EnumMapUrl.GPS;
      }
    }
  }


}
